import GoogleMapReact from 'google-map-react'

function Map({ location }) {
  const defaultProps = {
    zoom: 15,
  }

  const renderMarkers = (map, maps) => {
    let marker = new maps.Marker({
      position: location,
      map,
      title: 'Hello World!',
    })
    return marker
  }

  return (
    <div style={{ height: '300px', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY }}
        defaultCenter={location}
        defaultZoom={defaultProps?.zoom}
        styles={defaultProps.mapStyles}
        onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
      ></GoogleMapReact>
    </div>
  )
}

export default Map
